// subscriptionService.js
import api from "../../../utils/axiosInstance"
const ENDPOINT = "/subscriptions/"
class SubscriptionService {
  list = () => api.get(ENDPOINT).then((r) => r.data)
  get = (id) => api.get(`${ENDPOINT}${id}/`).then((r) => r.data)
  create = (p) => api.post(ENDPOINT, p)
  update = (id, p) => api.patch(`${ENDPOINT}${id}/`, p)
  remove = (id) => api.delete(`${ENDPOINT}${id}/`)
}
export default new SubscriptionService()
